module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_8003.8f15d175.png";